/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, effect, input, output, untracked } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faAngleDown, faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

import { AdaaHelper } from "../../../../core/utils";
import { Language } from "../../../constants/enums";
import { ValueText } from "../../../models";

@Component({
  selector: "adaa-form-dropdown-tree-node",
  imports: [FontAwesomeModule],
  template: `
    <li>
      @if (option().children && option().children!.length > 0) {
        <button (click)="isExpanded = !isExpanded">
          <fa-icon [icon]="isExpanded ? closeArrowIcon : expandArrowIcon" />
        </button>
      }
      <span [class.selected]="checkIfSelected(option().value)" (click)="selectOption(option().value)">
        {{ option().text }}</span
      >
      @if (isExpanded && option().children && option().children!.length > 0) {
        <ul>
          @for (item of option().children; track $index) {
            <adaa-form-dropdown-tree-node
              [isMultiple]="isMultiple()"
              [option]="item"
              [selectedValue]="_selectedValue"
              [hasSearch]="expandChild"
              (valueSelected)="valueChanged($event)"
            />
          }
        </ul>
      }
    </li>
  `,
})
export class FormDropdownTreeNodeComponent {
  readonly isMultiple = input<boolean>(false);
  readonly option = input.required<ValueText>();
  readonly selectedValue = input<any[]>([]);
  readonly hasSearch = input<boolean>(false);

  readonly valueSelected = output<any[]>();

  readonly expandArrowIcon = AdaaHelper.getCurrentLang() === Language.English ? faAngleRight : faAngleLeft;
  readonly closeArrowIcon = faAngleDown;
  isExpanded = false;
  expandChild = false;
  _selectedValue: any[] = [];

  constructor() {
    effect(() => {
      const search = this.hasSearch();
      untracked(() => {
        this.isExpanded = search;
        this.expandChild = search;
      });
    });

    // Preserve original behavior: _selectedValue is the same reference as the input array
    // so in-place mutations (push/splice) mirror the original @Input mutation pattern
    effect(() => {
      this._selectedValue = this.selectedValue();
    });
  }

  public checkIfSelected(value: any): boolean {
    return this._selectedValue ? this._selectedValue.findIndex((e) => e === value) > -1 : false;
  }

  public selectOption(value: any): void {
    if (this.isMultiple()) {
      const index = this._selectedValue.findIndex((e) => e === value);
      if (index > -1) {
        this._selectedValue.splice(index, 1);
      } else {
        this._selectedValue.push(value);
      }
    } else {
      this._selectedValue = [value];
    }
    this.valueSelected.emit(this._selectedValue);
  }

  public valueChanged(event: any[]): void {
    this._selectedValue = event;
    this.valueSelected.emit(this._selectedValue);
  }
}
